function loadYoutubeEmbed(classname: string): void {
    const ytframes: NodeListOf<HTMLIFrameElement> = document.querySelectorAll(classname);

    if (ytframes.length > 0) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const iframe = entry.target as HTMLIFrameElement;
                        const dataLoad = iframe.getAttribute('data-load');
                        if (dataLoad) {
                            iframe.src = dataLoad;
                            observer.unobserve(iframe);
                        }
                    }
                });
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1,
            },
        );

        ytframes.forEach((iframe) => {
            observer.observe(iframe);
        });
    }
}

export default loadYoutubeEmbed;
